import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, roles }) => {
  const { checking, user } = useAuth();
  const location = useLocation();
  if (checking) {
    return <main className="auth-loading" data-testid="auth-loading-state">Checking secure access…</main>;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "candidate" ? "/candidate-portal" : "/"} replace />;
  }
  return children;
};